import Repository from '../axios'

const resource = "/admin/system_setting/customer/sales-order-lead-time";

export default {
  getSoLeadTimeList() {
    return Repository.get(`${resource}`);
  },
  saveSoLeadTime(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
